import { useEffect, useState } from "react";
import axios from "axios";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Collection from "@/components/Product";
import Lifestyle from "@/components/Lifestyle";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Home = () => {
  const [products, setProducts] = useState([]);
  const [soldOut, setSoldOut] = useState([]);

  useEffect(() => {
    axios.get(`${API}/products`).then((r) => {
      setProducts(r.data.products);
      setSoldOut(r.data.sold_out || []);
    }).catch(() => {});
  }, []);

  return (
    <div className="relative">
      <Header />
      <Hero />
      <Marquee />
      <Manifesto />
      {products.length > 0 && <Collection products={products} soldOut={soldOut} />}
      <Lifestyle />
      <Footer />
      <CartDrawer />
    </div>
  );
};

export default Home;
